import * as React from 'react';
import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { styled, ThemeProvider } from '@mui/material/styles';
import NewHFLHeader from '../../commons/NewHFLHeader';
import NewHFLFooter from '../../commons/NewHFLFooter';
import { newHFLTheme, newHFLThemeVars } from '../../hd-ui-kit/NewHFLTheme';

interface NewHFLLayoutProps {
  children: ReactNode;
  contentMaxWidth?: string;
}

const SCPageContainer = styled(Box)(() => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'var(--Background-Default-Secondary, #F2F2F2)',
  color: 'var(--Text-Default-Primary, #280F1C)',
  fontFamily: 'var(--sds-typography-family-sans, "TWK Lausanne", sans-serif)',
  textAlign: 'left',
}));

function NewHFLLayout({ children, contentMaxWidth }: NewHFLLayoutProps) {
  return (
    <ThemeProvider theme={newHFLTheme}>
      <SCPageContainer sx={newHFLThemeVars as React.CSSProperties}>
        <NewHFLHeader contentMaxWidth={contentMaxWidth} />
        <Box sx={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>{children}</Box>
        <NewHFLFooter contentMaxWidth={contentMaxWidth} />
      </SCPageContainer>
    </ThemeProvider>
  );
}

export default NewHFLLayout;
